import React from "react";
import "./ProFiciency.css";

import BlogImg01 from "../assets/images/blog-img01.png";
import BlogImg02 from "../assets/images/blog-img02.png";
import BlogImg03 from "../assets/images/blog-img03.png";
import BlogImg04 from "../assets/images/blog-img04.png";
import BlogImg05 from "../assets/images/blog-img05.png";

const ProFiciency = () => {
  return (
    <div id="blogid" className="pro-ficiency-section">
      <div className="pro-ficiency-container">
         <div className="blog-title-bar">
            <div class="blog-title-text">Your insider's Guide to the Latest Articles in<span>Robotics and Automation</span></div>
             <div className="blog-title-ptag">Get up-to-date on industry trends and new solutions<br/> on our official company blog</div>
          </div>
          <div className="blog-pro-section">
            <div className="blog-content">
              <div className="blog-image"><a href="https://medium.com/@myequation/why-train-from-scratch-just-fine-tune-llms-using-hugging-face-instead-06208ffad7f2" target="_blank"><img src={BlogImg01} className="blog-img" /></a></div>
              <div className="blog-ptag"><a href="https://medium.com/@myequation/why-train-from-scratch-just-fine-tune-llms-using-hugging-face-instead-06208ffad7f2" target="_blank">Why Train from Scratch? Just Fine-Tune LLMs using Hugging Face Instead.</a></div>
            </div>
            <div className="blog-content">
              <div className="blog-image"><a href="https://medium.com/@myequation/wake-up-babe-andrej-karpathy-said-context-engineering-is-the-new-vibe-coding-302c141c07d6" target="_blank"><img src={BlogImg02} className="blog-img" /></a></div>
              <div className="blog-ptag"><a href="https://medium.com/@myequation/wake-up-babe-andrej-karpathy-said-context-engineering-is-the-new-vibe-coding-302c141c07d6" target="_blank">Wake up, babe!! Andrej Karpathy said “Context Engineering is the new vibe coding”</a></div>
            </div>
            <div className="blog-content">
              <div className="blog-image"><a href="https://medium.com/@myequation/master-oop-concepts-before-your-interview-turns-into-an-oops-moment-6b9c641a2114" target="_blank"><img src={BlogImg03} className="blog-img" /></a></div>
              <div className="blog-ptag"><a href="https://medium.com/@myequation/master-oop-concepts-before-your-interview-turns-into-an-oops-moment-6b9c641a2114" target="_blank">Master OOP Concepts Before Your Interview Turns Into an OOPs Moment.</a></div>
            </div>
            <div className="blog-content">
              <div className="blog-image"><a href="https://medium.com/@myequation/you-n8n-and-your-first-ai-agent-built-in-30-minutes-139613198091" target="_blank"><img src={BlogImg04} className="blog-img" /></a></div>
              <div className="blog-ptag"><a href="https://medium.com/@myequation/you-n8n-and-your-first-ai-agent-built-in-30-minutes-139613198091" target="_blank">You, n8n and your first AI Agent built in 30 Minutes</a></div>
            </div>
            <div className="blog-content">
              <div className="blog-image"><a href="https://medium.com/@myequation/why-write-10-lines-of-code-when-a-function-can-do-it-in-1-61c30c683cc2" target="_blank"><img src={BlogImg05} className="blog-img" /></a></div>
              <div className="blog-ptag"><a href="https://medium.com/@myequation/why-write-10-lines-of-code-when-a-function-can-do-it-in-1-61c30c683cc2" target="_blank">Why Write 10 Lines of Code, When a Function Can Do It in 1</a></div>
            </div>                                                
          </div>
          <div className="proficiency-content">
             <div className="proficiency-right">
               
              </div> 
          </div>
      </div>
    </div>
  );
};

export default ProFiciency;
